<template>
    <form v-if="post.isUserResponding" @submit.prevent="submitAnswerForm">
        <textarea
            v-model="answerFormText"
            :placeholder="$t('discussions.yourAnswer')"
            class="post_response__textarea form-control"
            name="answerText"
            cols="30"
            rows="5"
        >
        </textarea>
        <div class="actions">
            <TheButton :title="$t('discussions.respond')" classes="btn-sm" />
            <a href="#" class="post_response__close" @click.prevent="postData.isUserResponding = !postData.isUserResponding">{{
                $t('discussions.close')
            }}</a>
            <a href="#" class="post_response__rules" @click.prevent="showDiscussionRulesModal">{{ $t('discussions.rules') }}</a>
        </div>
    </form>
</template>

<script lang="ts">
import { PropType } from 'vue'
import PostModel from '~/models/Discussion/Post'
import TheButton from '~/components/ui/TheButton.vue'
import { useAuthStore } from '~/stores/auth'
import { useBasketStore } from '~/stores/basket'
import DiscussionUpsertRequest from '~/models/Api/DIscussion/DiscussionUpsertRequest'
export default {
    components: {
        TheButton,
    },
    props: {
        post: {
            type: Object as PropType<PostModel>,
            default: null,
        },
        answerSnippet: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            banned: false,
            answerFormText: this.answerSnippet || [],
            postData: this.post,
        }
    },
    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()
            return basketStore.authUser
        },
    },
    methods: {
        async upsertPost(requestBody: DiscussionUpsertRequest, successCallback: Function) {
            const authStore = useAuthStore()
            const accessToken: string | null = authStore.accessToken
            const upsert = await this.$repository.discussionUpsert(requestBody, { accessToken })

            if (upsert) {
                successCallback(this)
            }
        },

        isUserAuthenticated() {
            return this.authUser !== null
        },

        submitAnswerForm() {
            const { id: postId, parentPostId, productId } = this.postData
            const requestBody = {
                productId,
                title: '',
                text: this.answerFormText,
                parentPostId: parentPostId || postId,
            }
            useNuxtApp().$bus.$emit('resetDiscussionList')

            this.upsertPost(requestBody, () => {
                useNuxtApp().$bus.$emit('reloadDiscussionsList')
                useNuxtApp().$bus.$emit('showModal', 'thank-you-discussions')
                this.postData.isUserResponding = !this.postData.isUserResponding
            })
        },

        showDiscussionRulesModal() {
            useNuxtApp().$bus.$emit('showModal', 'discussion-rules')
        },
    },
}
</script>

<style lang="scss" scoped>
.post_response {
    &__textarea {
        width: 100%;
        resize: vertical;

        &:focus {
            outline: none !important;
            border-color: $color-cta;
            box-shadow: 0 0 10px $color-cta-extra-light;
        }
    }

    &__close {
        font-size: 14px;
        margin-left: 0.5rem;

        @include screen-md {
            margin-left: 1.5rem;
        }
    }

    &__rules {
        margin-left: auto;
        font-size: 12px;
        color: $color-grey-semi-dark;
        text-decoration: underline;

        &:hover {
            color: $color-green-dark;
        }
    }
}
.actions {
    display: flex;
    margin-top: 1rem;
    align-items: center;
}
</style>
